import { render, staticRenderFns } from "./block-charge-trend.vue?vue&type=template&id=288d4add&scoped=true&"
import script from "./block-charge-trend.vue?vue&type=script&lang=js&"
export * from "./block-charge-trend.vue?vue&type=script&lang=js&"
import style0 from "./block-charge-trend.vue?vue&type=style&index=0&id=288d4add&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288d4add",
  null
  
)

export default component.exports